import React, { useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { DialogAction } from '../../../function/useModal';
import { useTranslation } from 'react-i18next';

type ConfirmDialogProps = {
  dialog: DialogAction<ConfirmDialogResponse>;
  title?: string;
  message?: string;
  action?: string;
  cancel?: string;
};

export type ConfirmDialogResponse = {};

const useStyles = makeStyles(
  createStyles({
    button: {
      width: '150px',
    },
  })
);

const ConfirmDialog: React.FC<ConfirmDialogProps> = (props: ConfirmDialogProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [mode, setMode] = useState<boolean>(true);

  const tempMsg = t('ConfirmDialog.処理を行いますか?', '処理を行いますか?') ?? '処理を行いますか?';
  const msgs = (props.message ?? tempMsg).split('\n');

  return (
    <>
      <Dialog
        open={isOpen}
        fullScreen={false}
        onEntered={(e) => {}}
        onExited={(e) => {
          if (mode) {
            props.dialog.apply({});
          } else {
            props.dialog.cancel();
          }
        }}
      >
        <DialogTitle>{props.title ?? t('ConfirmDialog.確認', '確認')}</DialogTitle>
        <DialogContent>
          <div style={{ display: 'flow' }}>
            {msgs.map((msg) => (
              <div>{msg}</div>
            ))}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.button}
            color="primary"
            variant="contained"
            onClick={(e) => {
              setIsOpen(false);
              setMode(true);
            }}
          >
            {props.action ?? t('ConfirmDialog.適用', '適用')}
          </Button>
          <Button
            className={classes.button}
            color="primary"
            variant="contained"
            onClick={(e) => {
              setIsOpen(false);
              setMode(false);
            }}
          >
            {props.cancel ?? t('ConfirmDialog.キャンセル', 'キャンセル')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmDialog;
